import { useMemo, useState, useEffect } from "react";

import emailjs from "@emailjs/browser";

import { auth, registerWithEmailAndPassword, db } from "../../util/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { query, collection, getDocs, addDoc, where } from "firebase/firestore";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

import countryList from "react-select-country-list";

import { DatePicker } from "reactstrap-date-picker";

import { Link } from "react-router-dom";

import Swal from "sweetalert2";

import BarLoader from "react-spinners/BarLoader";

import { BiShow, BiHide } from "react-icons/bi";
// import { FaRegCircleCheck } from "react-icons/fa6";
// import { FaRegTimesCircle } from "react-icons/fa";

import { Input, Button } from "reactstrap";

import { useTranslation } from "react-i18next";

function RegisterPage() {
  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isChrome =
      /Chrome/i.test(navigator.userAgent) && !/Edg/i.test(navigator.userAgent);

    if (!isAndroid || !isChrome || !window.visualViewport) return;

    const setVH = () => {
      const vh = window.visualViewport.height * 0.01;
      document.documentElement.style.setProperty("--vvh", `${vh}px`);
    };

    setVH();
    window.visualViewport.addEventListener("resize", setVH);
    window.visualViewport.addEventListener("scroll", setVH);

    return () => {
      window.visualViewport.removeEventListener("resize", setVH);
      window.visualViewport.removeEventListener("scroll", setVH);
    };
  }, []);

  const { t } = useTranslation("common");

  const [username, setUsername] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [country, setCountry] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [dateOfBirth, setDateOfBirth] = useState();
  const [gender, setGender] = useState();
  const [language, setLanguage] = useState();
  const [ageIsConfirmed, setAgeIsConfirmed] = useState(false);
  const [
    termsAndConditionsAndPrivacyPolicyIsAgreed,
    setTermsAndConditionsAndPrivacyPolicyIsAgreed,
  ] = useState(false);

  const [usernames, setUsernames] = useState([]);
  const fetchUsernames = async () => {
    try {
      let fetchedUsernames = [];

      const q = query(collection(db, "users"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newUser = doc.data();

        if (newUser.username) {
          fetchedUsernames.push(newUser.username);
        }
      });

      setUsernames(fetchedUsernames);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching usernames");
    }
  };
  useEffect(() => {
    fetchUsernames();
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  const [user, loading, error] = useAuthState(auth);
  if (error) console.error(error);

  const countryOptions = useMemo(() => countryList().getData(), []);

  const [passwordInputType, setPasswordInputType] = useState("password");
  const togglePasswordInputType = () => {
    if (passwordInputType === "password") {
      setPasswordInputType("text");
    } else {
      setPasswordInputType("password");
    }
  };

  // const hasUpperCase = (string) => {
  //   return string !== string?.toLowerCase();
  // };

  // const hasLowerCase = (string) => {
  //   return string !== string?.toUpperCase();
  // };

  // const hasNumber = (string) => {
  //   return /\d/.test(string);
  // };

  // const hasAtLeast8Characters = (string) => {
  //   if (string?.length >= 8) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const register = async () => {
    if (password.length < 6) {
      Swal.fire({
        text: t("passwordMustBeAtLeast6CharactersLong"),
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }

    let verificationCodeInDB;

    try {
      const q = query(
        collection(db, "users"),
        where("usernameForVerification", "==", username)
      );
      const doc = await getDocs(q);
      if (doc.empty) {
        await Swal.fire({
          text: "No verification code found for this username.",
          icon: "error",
          confirmButtonColor: "#005EE1",
          confirmButtonText: "OKAY",
        });
        return;
      }
      const data = doc.docs[0].data();
      verificationCodeInDB = data.verificationCode;

      const entered = Number(verificationCode);
      if (Number.isInteger(entered) && verificationCodeInDB === entered) {
        registerWithEmailAndPassword(
          email,
          password,
          username,
          firstName,
          lastName,
          country,
          phoneNumber,
          dateOfBirth,
          gender,
          // language:
          language === "English"
            ? { label: "English", value: "en" }
            : { label: "Español", value: "es" },
          // bannerDesktop:
          "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FLogo%20Banners%2Fdesktop%2FBanner%20Spl.png?alt=media&token=5ede99d8-083f-4754-9d53-66579e01dbfa",
          // bannerMobile:
          "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FLogo%20Banners%2Fmobile%2FBanner%20Sp01.png?alt=media&token=8ecfa527-ec54-41f9-830d-cf495eeef53e",
          // tickets:
          150,
          // starCoins:
          0,
          // keys:
          2,
          // hasLogeedIn:
          false,
          t
        ).then(() => {
          Swal.fire({
            text: "Welcome to Sport League!",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });
        });
      } else {
        Swal.fire({
          text: "The verification code you entered is incorrect",
          icon: "error",
          confirmButtonColor: "#005EE1",
          confirmButtonText: "OKAY",
        });
      }
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  const [tab, setTab] = useState(1);
  const [isSendingVerificationCode, setIsSendingVerificationCode] =
    useState(false);

  const switchToTab2 = async () => {
    if (getAge(dateOfBirth) < 18) {
      Swal.fire({
        text: "You must be at least 18 years old to create an account",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
    } else if (usernames.includes(username)) {
      Swal.fire({
        text: "This username is already taken",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
    } else {
      setIsSendingVerificationCode(true);

      const verificationCode = Math.floor(100000 + Math.random() * 900000);

      const serviceId = "sportleague_outlook";
      const templateId = "verificationCode";
      const publicKey = "Ki5BETKiWrS6RDEP_";

      const templateParams = {
        toEmail: email,
        toUsername: username,
        verificationCode,
      };

      try {
        await addDoc(collection(db, "users"), {
          usernameForVerification: username,
          verificationCode,
        });
      } catch (err) {
        console.error(err);
        alert(err.message);
      }

      await emailjs.send(serviceId, templateId, templateParams, publicKey).then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
      setTab(2);

      Swal.fire({
        title: t("verificationCodeSent"),
        text: t("weveSentYouAnEmailWithYourVerificationCode"),
        icon: "success",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });

      setIsSendingVerificationCode(false);
    }
  };

  const [verificationCode, setVerificationCode] = useState();

  if (loading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div
      id="loginPage"
      style={{
        /* prefer CSS units; fall back to variable for Chrome */
        minHeight: "calc(var(--vvh, 1vh) * 100)",
      }}
    >
      <div className="loginContainer" style={{ marginTop: "1rem" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h1>{t("register").toUpperCase()}</h1>
          {tab === 1 ? (
            <>
              <p
                className="inputLabel"
                style={{ textAlign: "left", marginTop: "1rem" }}
              >
                {t("username")}
              </p>
              <Input
                type="text"
                className="authInput"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                placeholder={t("yourUsername")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("firstName")}
              </p>
              <Input
                type="text"
                className="authInput"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={t("yourFirstName")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("lastName")}
              </p>
              <Input
                type="text"
                className="authInput"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={t("yourLastName")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("email")}
              </p>
              <Input
                type="text"
                className="authInput"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("yourEmail")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("country")}
              </p>
              <Input
                type="select"
                className="authInput"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                defaultValue={""}
              >
                <option value="" disabled>
                  {t("yourCountry")}
                </option>
                {countryOptions.map((countryOption) => {
                  return (
                    <option value={countryOption.label}>
                      {countryOption.label}
                    </option>
                  );
                })}
              </Input>
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("phoneNumber")}
              </p>
              <PhoneInput
                placeholder={t("yourPhoneNumber")}
                value={phoneNumber}
                onChange={setPhoneNumber}
              />
              {/* <Input
                  type="text"
                  className="authInput"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Your country code & phone number"
                /> */}
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("birthDate")}
              </p>
              <DatePicker
                id="user-birthdate-date-datepicker"
                className="authInput"
                style={{ borderRadius: 10 }}
                showClearButton={false}
                value={dateOfBirth}
                onChange={(v) => setDateOfBirth(v)}
                dateFormat="DD.MM.YYYY"
                placeholder={t("yourBirthDate")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("gender")}
              </p>
              <Input
                type="select"
                className="authInput"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                defaultValue={""}
              >
                <option value="" disabled>
                  {t("yourGender")}
                </option>
                <option value="Male">{t("male")}</option>
                <option value="Female">{t("female")}</option>
                <option value="Non-binary">{t("nonBinary")}</option>
              </Input>
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("language")}
              </p>
              <Input
                type="select"
                className="authInput"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                defaultValue={""}
                style={{ marginBottom: "1rem" }}
              >
                <option value="" disabled>
                  {t("yourLanguage")}
                </option>
                <option value="English">English</option>
                <option value="Spanish">Español</option>
              </Input>
            </>
          ) : (
            <>
              <p
                className="inputLabel"
                style={{ textAlign: "left", marginTop: "1rem" }}
              >
                {t("verificationCode")}
              </p>
              <Input
                type="number"
                className="authInput"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                placeholder={t("yourVerificationCode")}
              />
              <p className="inputLabel" style={{ textAlign: "left" }}>
                {t("password")}
              </p>
              <div style={{ position: "relative", marginBottom: "0.5rem" }}>
                <Input
                  type={passwordInputType}
                  className="authInput"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("yourPassword")}
                />
                {passwordInputType === "password" ? (
                  <BiShow
                    onClick={togglePasswordInputType}
                    style={{
                      position: "absolute",
                      top: 7.5,
                      right: 10,
                      width: 25,
                      height: 25,
                      cursor: "pointer",
                      color: "#005EE1",
                    }}
                  />
                ) : (
                  <BiHide
                    onClick={togglePasswordInputType}
                    style={{
                      position: "absolute",
                      top: 7.5,
                      right: 10,
                      width: 25,
                      height: 25,
                      cursor: "pointer",
                      color: "#005EE1",
                    }}
                  />
                )}
              </div>
              {/* <div style={{ marginBottom: "0.5rem" }}>
                <p className="registerPasswordValidationField">
                  {hasUpperCase(password) ? (
                    <FaRegCircleCheck style={{ color: "#005EE1" }} />
                  ) : (
                    <FaRegTimesCircle />
                  )}
                  {t("atLeast1UpperCaseLetter")}
                </p>
                <p className="registerPasswordValidationField">
                  {hasLowerCase(password) ? (
                    <FaRegCircleCheck style={{ color: "#005EE1" }} />
                  ) : (
                    <FaRegTimesCircle />
                  )}
                  {t("atLeast1LowerCaseLetter")}
                </p>
                <p className="registerPasswordValidationField">
                  {hasNumber(password) ? (
                    <FaRegCircleCheck style={{ color: "#005EE1" }} />
                  ) : (
                    <FaRegTimesCircle />
                  )}
                  {t("atLeast1Number")}
                </p>
                <p className="registerPasswordValidationField">
                  {hasAtLeast8Characters(password) ? (
                    <FaRegCircleCheck style={{ color: "#005EE1" }} />
                  ) : (
                    <FaRegTimesCircle />
                  )}
                  {t("atLeast8Characters")}
                </p>
              </div> */}
              <p style={{ marginBottom: "0.5rem" }}>
                <Input
                  type="checkbox"
                  checked={ageIsConfirmed}
                  onChange={() => setAgeIsConfirmed(!ageIsConfirmed)}
                  style={{ marginRight: "0.5rem" }}
                />
                {t("iCertifyThatIAmOver18YearsOld")}
              </p>
              <p>
                <Input
                  type="checkbox"
                  checked={termsAndConditionsAndPrivacyPolicyIsAgreed}
                  onChange={() =>
                    setTermsAndConditionsAndPrivacyPolicyIsAgreed(
                      !termsAndConditionsAndPrivacyPolicyIsAgreed
                    )
                  }
                  style={{ marginRight: "0.5rem" }}
                />
                {t("iAgreeToThe")}{" "}
                <a
                  href="/terms-and-conditions"
                  target="_blank"
                  rel="noreferrer"
                  className="authLink"
                >
                  {t("terms&Conditions")}
                </a>{" "}
                {t("and")}{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  className="authLink"
                >
                  {t("privacyPolicy")}
                </a>
                .
              </p>
            </>
          )}
        </div>
        {tab === 1 ? (
          <Button
            className="primaryBtn"
            onClick={switchToTab2}
            style={{ marginTop: "0.5rem" }}
            disabled={
              !username ||
              !firstName ||
              !lastName ||
              !email ||
              !country ||
              !phoneNumber ||
              !dateOfBirth ||
              !gender ||
              isSendingVerificationCode
            }
          >
            {isSendingVerificationCode
              ? t("loading").toUpperCase()
              : t("next").toUpperCase()}
          </Button>
        ) : (
          <>
            <Button
              className="primaryBtn"
              onClick={register}
              style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}
              disabled={
                !username ||
                !firstName ||
                !lastName ||
                !email ||
                !password ||
                // !hasUpperCase(password) ||
                // !hasLowerCase(password) ||
                // !hasNumber(password) ||
                // !hasAtLeast8Characters(password) ||
                !country ||
                !phoneNumber ||
                !dateOfBirth ||
                !gender ||
                !ageIsConfirmed ||
                !termsAndConditionsAndPrivacyPolicyIsAgreed ||
                !verificationCode
              }
            >
              {t("register").toUpperCase()}
            </Button>
            <Button
              className="secondaryBtn"
              onClick={() => setTab(1)}
              style={{ marginBottom: "1rem", color: "#005EE1" }}
            >
              {t("back").toUpperCase()}
            </Button>
          </>
        )}
        <p style={{ marginBottom: 0 }}>
          {t("alreadyHaveAnAccount")}{" "}
          <Link className="authLink" to="/login">
            {t("signIn")}
          </Link>
        </p>
      </div>
    </div>
  );
}

export default RegisterPage;
